module.exports = __webpack_public_path__ + "static/media/opnemen_spaargeld.cfae6389.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/opnemen_spaargeld.svg
// module id = 945
// module chunks = 0